import { SVGProps, Ref, forwardRef } from 'react';

export const HhProGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M20.864 5.65c.087.303.688 2.393.884 4.58h.018l.046.569c.099 1.191-.307 2.329-1.129 3.214-.875.938-2.13 1.342-3.457 1.342H6.78c-1.318 0-2.582-.404-3.457-1.343A4.22 4.22 0 0 1 2.186 10.8l.045-.569c.208-2.31.867-4.523.894-4.613a.73.73 0 0 1 .55-.496.7.7 0 0 1 .696.243l.578.686c.704.849 1.805 1.282 2.933 1.156 1.11-.126 2.068-.776 2.555-1.742l.903-1.779a.72.72 0 0 1 .64-.397H12c.262 0 .514.145.64.397l.904 1.779c.487.966 1.444 1.616 2.554 1.742a3.34 3.34 0 0 0 2.934-1.156l.578-.686a.724.724 0 0 1 1.246.253z"
                fill="#919191"
            />
            <path d="M4.417 16.371a1.453 1.453 0 1 0 0 2.907h15.168a1.453 1.453 0 1 0 0-2.907z" fill="#919191" />
        </g>
    </svg>
));
HhProGrayscaleSize24Glyph.displayName = 'HhProGrayscaleSize24Glyph';
